// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Skeleton de la page Chiffrage. Le shimmer vient de ContentSkeleton.css (\`.cskel\`) : ici on ne pose
   que les gabarits, aux dimensions des vrais elements — sinon le contenu ferait sauter la page en
   arrivant, ce que le skeleton est justement cense eviter. */

.chskel-banner {
  display: block;
  height: 7rem;
  border-radius: 0.8rem;
  margin-bottom: 1.5rem;
}

.chskel-toolbar {
  display: flex;
  align-items: center;
  gap: 1.2rem;
  flex-wrap: wrap;
  margin: 1.5rem 0;
}

/* Hauteur 3.8rem = celle des boutons ET du menu de reprise dans la vraie barre. */
.chskel-btn {
  display: block;
  height: 3.8rem;
  width: 16rem;
  border-radius: 0.8rem;
  flex-shrink: 0;
}

.chskel-select {
  display: block;
  height: 3.8rem;
  flex: 1 1 52rem;
  min-width: 34rem;
  max-width: 80rem;
  border-radius: 1rem;
}

.chskel-table {
  border: 1px solid #e5e7eb;
  border-radius: 0.8rem;
  overflow: hidden;
}

/* 7 colonnes, memes proportions que la table reelle : N°Ref, Description (large), Unite, Quantite,
   Prix, Total, Actions. */
.chskel-head,
.chskel-row {
  display: grid;
  grid-template-columns: 1fr 3fr 1fr 1fr 1.4fr 1.4fr 0.8fr;
  gap: 1.2rem;
  align-items: center;
  padding: 1.2rem 1.6rem;
}

.chskel-head {
  background: #f8f9fa;
  border-bottom: 1px solid #e5e7eb;
}

.chskel-row + .chskel-row,
.chskel-row {
  border-top: 1px solid #f1f2f4;
}

.chskel-cell {
  display: block;
  height: 1.4rem;
  border-radius: 0.4rem;
}

/* Bouton d'ajout : dans le tableau, borde en pointilles, avec la marge de 1rem du vrai. */
.chskel-add {
  display: block;
  height: 3.8rem;
  margin: 1rem;
  border-radius: 0.4rem;
}

.chskel-total {
  display: flex;
  justify-content: flex-end;
  padding: 1.6rem 0;
}

.chskel-total-bar {
  display: block;
  height: 1.8rem;
  width: 22rem;
  border-radius: 0.4rem;
}

.chskel-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 1.2rem;
  border-top: 1px solid #e5e7eb;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Chiffrage/components/ChiffrageSkeleton.css"],"names":[],"mappings":"AAAA;;6DAE6D;;AAE7D;EACE,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,kFAAkF;AAClF;EACE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;0BAC0B;AAC1B;;EAEE,aAAa;EACb,wDAAwD;EACxD,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA,0FAA0F;AAC1F;EACE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EACnB,6BAA6B;AAC/B","sourcesContent":["/* Skeleton de la page Chiffrage. Le shimmer vient de ContentSkeleton.css (`.cskel`) : ici on ne pose\n   que les gabarits, aux dimensions des vrais elements — sinon le contenu ferait sauter la page en\n   arrivant, ce que le skeleton est justement cense eviter. */\n\n.chskel-banner {\n  display: block;\n  height: 7rem;\n  border-radius: 0.8rem;\n  margin-bottom: 1.5rem;\n}\n\n.chskel-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 1.2rem;\n  flex-wrap: wrap;\n  margin: 1.5rem 0;\n}\n\n/* Hauteur 3.8rem = celle des boutons ET du menu de reprise dans la vraie barre. */\n.chskel-btn {\n  display: block;\n  height: 3.8rem;\n  width: 16rem;\n  border-radius: 0.8rem;\n  flex-shrink: 0;\n}\n\n.chskel-select {\n  display: block;\n  height: 3.8rem;\n  flex: 1 1 52rem;\n  min-width: 34rem;\n  max-width: 80rem;\n  border-radius: 1rem;\n}\n\n.chskel-table {\n  border: 1px solid #e5e7eb;\n  border-radius: 0.8rem;\n  overflow: hidden;\n}\n\n/* 7 colonnes, memes proportions que la table reelle : N°Ref, Description (large), Unite, Quantite,\n   Prix, Total, Actions. */\n.chskel-head,\n.chskel-row {\n  display: grid;\n  grid-template-columns: 1fr 3fr 1fr 1fr 1.4fr 1.4fr 0.8fr;\n  gap: 1.2rem;\n  align-items: center;\n  padding: 1.2rem 1.6rem;\n}\n\n.chskel-head {\n  background: #f8f9fa;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.chskel-row + .chskel-row,\n.chskel-row {\n  border-top: 1px solid #f1f2f4;\n}\n\n.chskel-cell {\n  display: block;\n  height: 1.4rem;\n  border-radius: 0.4rem;\n}\n\n/* Bouton d'ajout : dans le tableau, borde en pointilles, avec la marge de 1rem du vrai. */\n.chskel-add {\n  display: block;\n  height: 3.8rem;\n  margin: 1rem;\n  border-radius: 0.4rem;\n}\n\n.chskel-total {\n  display: flex;\n  justify-content: flex-end;\n  padding: 1.6rem 0;\n}\n\n.chskel-total-bar {\n  display: block;\n  height: 1.8rem;\n  width: 22rem;\n  border-radius: 0.4rem;\n}\n\n.chskel-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  padding-top: 1.2rem;\n  border-top: 1px solid #e5e7eb;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
